import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { IoArrowBack } from "react-icons/io5";
import Card from "../components/Card";
import CardForm from "../components/CardForm";
import Header from "./Header";

import { setValue, setFontSize } from "../reducers/actions";

class Step2 extends Component {
  state = {
    selectedIndex: 0
  };

  render() {
    const layout = this.props.layouts[this.props.currentLayout];

    let width = 260;

    if (window.innerWidth <= 375) {
      width = 220;
    }

    return (
      <div className="t-mobile-container step2">
        <Header />
        <div className="t-alert">
          <span className="t-secondary-title">STEP2</span> テキストの入力
        </div>
        <div className="t-main">
          <Card
            objects={layout.objects}
            values={this.props.values}
            fontSizes={this.props.fontSizes}
            selectedIndex={this.state.selectedIndex}
            width={width}
            showPlaceholder={true}
            sample={false}
          />
        </div>
        <div className="t-secondary">
          <CardForm
            layout={layout}
            values={this.props.values}
            fontSizes={this.props.fontSizes}
            selectedIndex={this.state.selectedIndex}
            onIndexChanged={(index) => {
              this.setState({selectedIndex: index});
            }}
            onValueChanged={(id, value) => {
              this.props.setValue(id, value);
            }}
            onFontSizeChanged={(id, value) => {
              this.props.setFontSize(id, value);
            }}
          />
        </div>
        <div className="t-footer">
          <div className="t-footer-actions">
            <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-secondary btn-icon"><IoArrowBack /></Link>
            <Link to={`${process.env.PUBLIC_URL}/step3`} className="btn btn-primary">次へ: 数量の選択</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f,{ setValue, setFontSize })(Step2);